const SandboxSection = ({ inputs, setInputs, parsedInputs, executeEndpoint, running, error, result }) => (
  <div>
    <div className="grid" style={{ gap: "12px" }}>
      <div>
        <label className="field-label">Inputs (JSON)</label>
        <textarea value={inputs} onChange={(e) => setInputs(e.target.value)} rows={6} className="code-block" />
        {!parsedInputs && <p className="muted">Inputs must be valid JSON.</p>}
      </div>
    </div>

    <div className="section-header" style={{ marginTop: "12px" }}>
      <button className="button" onClick={executeEndpoint} disabled={running || !parsedInputs} type="button">
        {running ? "Running..." : "Run endpoint"}
      </button>
    </div>

    {error && <p className="muted" style={{ color: "#b00020", marginTop: "12px" }}>{error}</p>}
    {result && (
      <div className="panel" style={{ background: "#0f172a", color: "#e2e8f0", marginTop: "12px" }}>
        <div className="section-header" style={{ marginBottom: "8px" }}>
          <div className="section-header__title" style={{ color: "#e2e8f0" }}>Result</div>
        </div>
        <pre style={{ whiteSpace: "pre-wrap" }}>{JSON.stringify(result, null, 2)}</pre>
      </div>
    )}
  </div>
);

export default SandboxSection;
